'use client';
import React, { useState } from 'react';
import Hero from './hero';
import Content from './content';
import TawkTo from '../componenets/Tawko';
import Data from '../data/blog/blogs.json';
import MainData from '@/app/data/MainState';
import Tawko2 from '../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  const [filteredData, setfilteredData] = useState(Data);
  console.log(MainData, 'mmmmmm');
  const handleSearch = (searchTerm) => {
    const filtered = Data.filter((blogs) =>
      blogs.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setfilteredData(filtered);
  };

  return (
    <div>
      <title>Expert Tips & Insights on Luxury Travel Services</title>
      <meta
        name="description"
        content="Explore the Prestige Ride blog for expert tips, insights, and news on luxury transportation services. Stay updated on travel trends, chauffeur tips, and more to elevate your journey with us."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link rel="canonical" href="https://www.prestigeride.com/blog" />
      <TawkTo />
      <Navbar />
      <Hero onSearch={handleSearch} />
      <Content filteredData={filteredData} />
      <Tawko2 />
      <Footer />
    </div>
  );
}

export default page;
